<template>
  <div class="clearfix" v-if="!pageLoad">
    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-if="pageLoad" class="card mb-25 border-0 rounded-0 bg-white letter-spacing">

    <div class="card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 gap-10">
      <div class="position-relative" style="min-width: 220px; max-width: 300px; flex: 1 1 auto;">
        <input
          v-model="searchQuery"
          type="text"
          class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
          placeholder="Rechercher..."
        />
      </div>
      <div class="d-flex align-items-center">
         <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#companyModal"
          style="background-color: #EB9355;"
          @click="initField"
          v-if="current_permissions('create_fee')"
        >
          {{ $t('fees.addFee') }}
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button>

        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#companyModalBulk"
          style="background-color: #6560F0;"
          v-if="current_permissions('create_all_fee')"
        >
          {{ $t('fees.bulkFees') }}
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button>
      </div>
    </div>

    <!-- <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
      </div>
      <div class="d-flex align-items-center">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#companyModal"
          style="background-color: #EB9355;"
          @click="initField"
          v-if="current_permissions('create_fee')"
        >
          {{ $t('fees.addFee') }}
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button>

        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#companyModalBulk"
          style="background-color: #6560F0;"
          v-if="current_permissions('create_all_fee')"
        >
          {{ $t('fees.bulkFees') }}
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button>
      </div>
    </div> -->
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('fees.code') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('fees.organization') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('fees.country') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('fees.operator') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('fees.name') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('fees.value') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('fees.mode') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('fees.feeType') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('fees.status') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(fee) in paginatedFees" :key="fee.id">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ fee.code }}
              </td>
              <td v-if="fee.organization!==null" class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ fee.organization.name }}
              </td>
              <td v-if="fee.organization===null" class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ '' }}
              </td>
              <td v-if="fee.country!==null" class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ fee.country.name }}
              </td>
              <td v-if="fee.country===null" class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ '' }}
              </td>
              <td v-if="fee.operator!==null" class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ fee.operator.mnoName }}
              </td>
              <td v-if="fee.operator===null" class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ '' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ fee.name }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ fee.value }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ fee.mode }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ fee.typeFee.name }}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                <span class="badge text-outline-success" v-if="fee.status==='ACTIVE'">{{ $t('fees.active') }}</span>
                <span class="badge text-outline-danger" v-if="fee.status==='INACTIVE'">{{ $t('fees.inactive') }}</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <div class="dropdown">
                  <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="changeStatus(fee.status,fee.code)" v-if="current_permissions('status_fee')">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        <span v-if="fee.status==='ACTIVE'">{{ $t('fees.deactivate') }}</span>
                        <span v-if="fee.status==='INACTIVE'">{{ $t('fees.activate') }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="filteredTotal>0" class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
        <p v-if="filteredTotal>10" class="mb-0 text-paragraph">
          {{ $t('fees.showing') }} <span class="fw-bold">{{ page*10 }}</span> {{ $t('fees.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('fees.results') }}
        </p>
        <p v-if="filteredTotal<=10" class="mb-0 text-paragraph">
          {{ $t('fees.showing') }} <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('fees.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('fees.results') }}
        </p>
        <nav class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li v-if="(page-1)>0" class="page-item">
              <a class="page-link" @click="goToPage(page-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in numPages" :key="numPage" class="page-item">
              <a v-if="numPage==page" class="page-link active" href="#">{{ numPage }}</a>
              <a v-else class="page-link" @click="goToPage(numPage)">{{ numPage }}</a>
            </li>
            <li v-if="(page+1)<=numPages" class="page-item">
              <a class="page-link" @click="goToPage(page+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <!-- Modal Bulk Fees -->
  <div class="modal fade" id="companyModalBulk" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <form @submit.prevent="storeFeeBulk">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ $t('fees.bulkFees') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="errorsBulk!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorIdBulk}}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorsBulk}}</h6>
            </div>
            <div v-if="successBulk!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ successBulk}}</h6>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="col-md-6">
                <label class="d-block text-black fw-semibold mb-10">{{ $t('fees.organization') }}</label>
                <select name="organization" id="organization" class="form-select fs-md-15 text-black shadow-none" v-model="selectedOrganization" required>
                  <option value="">{{ $t('fees.select') }}</option>
                  <option v-for="organization in organizations" :value="organization.code" :key="organization.code"> {{ organization.name }}</option>
                </select>
              </div>

              <div v-for="(fee, index) in feeList" :key="index" class="row mb-3">
                <div class="col-md-6">
                  <label class="form-label">{{ $t('fees.feeType') }}</label>
                  <input v-model="fee.name" type="text" class="form-control" disabled />
                </div>
                <div class="col-md-6">
                  <label class="form-label">{{ $t('fees.value') }}</label>
                  <input v-model.number="fee.valeur" type="number" class="form-control" :class="{ 'is-invalid': errorsBis[index]?.valeur }" />
                  <span class="invalid-feedback">{{ errorsBis[index]?.valeur }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn text-white" style="background-color: #EB9355;" v-if="current_permissions('create_all_fee')">
              <i class="flaticon-plus position-relative ms-5 fs-12" style="color: #FFF;"></i>
              {{ $t('fees.save') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Modal Create Fee -->
  <div class="modal fade" id="companyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <form @submit.prevent="storeFee">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ $t('fees.fee') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="errors!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId}}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
            </div>
            <div v-if="success!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ success}}</h6>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('fees.name') }}</label>
                  <div>
                    <input v-model="formValues.name" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="$t('fees.namePlaceholder')" @blur="validate('name')" @keyup="validate('name')" :class="{ 'is-invalid': errorsBis['name'] }" />
                    <span class="invalid-feedback">{{ errorsBis['name']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('fees.value') }}</label>
                  <div>
                    <input v-model="formValues.valeur" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="$t('fees.valuePlaceholder')" @blur="validate('valeur')" @keyup="validate('valeur')" :class="{ 'is-invalid': errorsBis['valeur'] }" />
                    <span class="invalid-feedback">{{ errorsBis['valeur']}}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('fees.mode') }}</label>
                  <select name="mode" id="mode" class="form-select fs-md-15 text-black shadow-none" @change="handleModeChange" required>
                    <option value="" :selected="selectedMode==''">{{ $t('fees.select') }}</option>
                    <option value="PERCENT" :selected="selectedMode=='PERCENT'">{{ $t('fees.percent') }}</option>
                    <option value="VALUE" :selected="selectedMode=='VALUE'">{{ $t('fees.valueType') }}</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('fees.feeType') }}</label>
                  <select name="typefee" id="typefee" class="form-select fs-md-15 text-black shadow-none" @change="handleTypeFeeChange" required>
                    <option value="" :selected="selectedTypeFee==''">{{ $t('fees.select') }}</option>
                    <option value="COLLECT" :selected="selectedTypeFee=='COLLECT'">{{ $t('fees.operatorCollectFee') }}</option>
                    <option value="I-MONEY" :selected="selectedTypeFee=='I-MONEY'">{{ $t('fees.iMoneyCollectFee') }}</option>
                    <option value="PAYOUT" :selected="selectedTypeFee=='PAYOUT'">{{ $t('fees.operatorPayoutFee') }}</option>
                    <option value="I-MONEY PAYOUT" :selected="selectedTypeFee=='I-MONEY PAYOUT'">{{ $t('fees.iMoneyPayoutFee') }}</option>
                    <option value="BANK_REPAYMENT" :selected="selectedTypeFee=='BANK_REPAYMENT'">{{ $t('fees.bankRepayment') }}</option>
                    <option value="CRYPTO_REPAYMENT" :selected="selectedTypeFee=='CRYPTO_REPAYMENT'">{{ $t('fees.cryptoRepayment') }}</option>
                    <option value="TOPUP" :selected="selectedTypeFee=='TOPUP'">{{ $t('fees.topup') }}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6" v-if="selectedTypeFee!=='COLLECT' && selectedTypeFee!=='PAYOUT'">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('fees.organization') }}</label>
                  <select name="organization" id="organization" class="form-select fs-md-15 text-black shadow-none" v-model="selectedOrganization" required>
                    <option value="">{{ $t('fees.select') }}</option>
                    <option v-for="organization in organizations" :value="organization.code" :key="organization.code"> {{ organization.name }}</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('fees.country') }}</label>
                  <select name="country" id="country" class="form-select fs-md-15 text-black shadow-none" @change="handleCountryChange" required>
                    <option value="">{{ $t('fees.select') }}</option>
                    <option v-for="country in countries" :value="country.countryCode" :key="country.code" :selected="selectedCountry==country.countryCode"> {{ country.name }}</option>
                  </select>
                </div>
              </div>
              <div class="row" v-if="selectedTypeFee=='COLLECT' || selectedTypeFee=='PAYOUT'">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('fees.operators') }}</label>
                  <select name="operator" id="operator" class="form-select fs-md-15 text-black shadow-none" @change="handleOperatorChange" required>
                    <option value="">{{ $t('fees.select') }}</option>
                    <option v-for="operator in operators" :value="operator.code" :key="operator.code" :selected="selectedOperator==operator.code"> {{ operator.mnoName }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn text-white" style="background-color: #EB9355;" v-if="current_permissions('create_fee')">
              <i class="flaticon-plus position-relative ms-5 fs-12" style="color: #FFF;"></i>
              {{ $t('fees.save') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div id="snackbar"></div>
</template>

<script setup lang="ts">
import { ref, onMounted, reactive, inject } from "vue";
import axios from 'axios';
import router from '../../router/index'
import { showToast, checkSessionValidate } from "../../utils/function";
import { useTableFilter } from "../../utils/UseTablefilter";
import { current_permissions } from '../../utils/permission';
import { useRoute, useRouter } from 'vue-router'
import * as yup from 'yup';
import { Country, Fee, Operator, Organization, TypeFree } from "@/utils/Model";

const backApi = inject('back');
let edit = 0;
let itemCode = '';
let code: string | null = '';
const selectedOrganization = ref('');
const selectedOperator = ref('');
const selectedCountry = ref('');
const selectedTypeFee = ref('');
const selectedMode = ref('');

const loader = ref(false);
let token: string | null = localStorage.getItem('login_token');

const countries = ref(new Array<Country>());
const fees = ref(new Array<Fee>());
const organizations = ref(new Array<Organization>());
const operators = ref(new Array<Operator>());
const typefees = ref(new Array<TypeFree>());
let operatorsTemp = new Array<Operator>();
let countriesTemp = new Array<Country>();

const errors = ref('');
const errorId = ref('');
const success = ref('');
const errorIdBulk = ref('');
const errorsBulk = ref('');
const successBulk = ref('');

const errorsBis: any = { 'name': '', 'valeur': '' };
const pageLoad = ref(false);

const formValues = reactive({
  valeur: "",
  name: ""
});

const {
  searchQuery,
  paginatedData: paginatedFees,
  filteredTotal,
  page,
  numPages,
  pageSize,
  showingFrom,
  showingTo,
  goToPage,
} = useTableFilter(
  fees,
  [
    (f: any) => f.code,
    (f: any) => f.organization?.name,
    (f: any) => f.country?.name,
    (f: any) => f.operator?.mnoName,
    (f: any) => f.name,
    (f: any) => f.value,
    (f: any) => f.mode,
    (f: any) => f.typeFee?.name,
    (f: any) => f.status,
  ],
  15
);

const schema = yup.object({
  valeur: yup.number().required('La valeur est requise'),
  name: yup.string().required('Le nom du frais est requis'),
});

const feeList = ref([
  { name: "I-MONEY", valeur: 0 },
  { name: "I-MONEY PAYOUT", valeur: 0 },
  { name: "BANK_REPAYMENT", valeur: 0 },
  { name: "CRYPTO_REPAYMENT", valeur: 0 },
  { name: "TOPUP", valeur: 0 },
]);

const initField = () => {
  formValues.name = '';
  formValues.valeur = "";
  selectedOrganization.value = code || '';
  selectedOperator.value = '';
  selectedTypeFee.value = '';
  selectedMode.value = '';
  selectedCountry.value = '';
  itemCode = '';
  edit = 0;
  errorId.value = '';
  errors.value = '';
}

function handleOrganizationChange(event) {
  selectedOrganization.value = event.target.value;
}

function handleOperatorChange(event) {
  selectedOperator.value = event.target.value;
}

function handleTypeFeeChange(event) {
  selectedTypeFee.value = event.target.value;
}

function handleModeChange(event) {
  selectedMode.value = event.target.value;
}

function handleCountryChange(event) {
  var i = 0;
  while (i < countriesTemp.length) {
    if (countriesTemp[i].countryCode == event.target.value) {
      selectedCountry.value = countriesTemp[i].code;
    }
    i++;
  }
  var j = 0;
  var operatorArr = new Array<Operator>();
  while (j < operatorsTemp.length) {
    if (operatorsTemp[j].countryCode == event.target.value) {
      operatorArr.push(operatorsTemp[j]);
    }
    j++;
  }
  operators.value = operatorArr;
}

function formatDateFr(value) {
  if (value) {
    const year = value.getFullYear();
    let month = value.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let day = value.getDate();
    day = day < 10 ? '0' + day : day;
    return day + '/' + month + '/' + year;
  }
}

// Récupère une page de frais depuis l'API (forme { data, pagination })
const fetchFeesPage = (targetPage: number) => {
  return axios.get(backApi + '/secure/fees/?organization=' + (code || '') + '&currentPage=' + targetPage, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}

const getFees = async () => {
  try {
    const first = await fetchFeesPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = parseInt(first.data.pagination?.numPages ?? 1);

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchFeesPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    fees.value = collected;
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const getOrganizations = () => {
  axios.get(backApi + '/secure/organizations/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      organizations.value = response.data.data ?? response.data;
      console.log(response.data);
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const getTypeFees = () => {
  axios.get(backApi + '/secure/typefees/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      typefees.value = response.data.data ?? response.data;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const getCountries = () => {
  axios.get(backApi + '/secure/countries/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      const list = response.data.data ?? response.data;
      countriesTemp = list;
      countries.value = list;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const getOperators = () => {
  axios.get(backApi + '/public/operators/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      operatorsTemp = response.data.data ?? response.data;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const changeStatus = (status, code) => {
  axios.put(`${backApi}/secure/fees/${code}/status`, {
    code: code,
    status: (status == 'ACTIVE') ? 'INACTIVE' : 'ACTIVE'
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    router.go();
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const storeFee = () => {
  try {
    schema.validateSync(formValues);
    axios.post(`${backApi}/secure/fees/new`, {
      value: parseFloat(formValues.valeur),
      name: formValues.name,
      organization: selectedOrganization.value,
      country: selectedCountry.value,
      operator: selectedOperator.value,
      mode: selectedMode.value,
      typeFee: selectedTypeFee.value
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.status === 200) {
        showToast("Frais de type " + selectedTypeFee.value.toLowerCase() + " enregistré avec succès", "green");
        initField();
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
  }
}

const storeFeeBulk = () => {
  errorIdBulk.value = '';
  errorsBulk.value = '';
  successBulk.value = '';

  try {
    const feesPayload = feeList.value.map(fee => ({
      typeFee: fee.name,
      value: Number(fee.valeur) || 0
    }));

    axios.post(`${backApi}/secure/fees/all`, {
      organization: selectedOrganization.value,
      fees: feesPayload
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.status === 200) {
        showToast("Operation reussie", "green");
        feeList.value.forEach(fee => fee.valeur = 0);
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorIdBulk.value = error.response.data.errorId;
          errorsBulk.value = error.response.data.message;
        }
        showToast(error.response.data.message, "red");
      }
    });
  } catch (error) {
    errorsBulk.value = "une erreur inattendue est apparue"
  }
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = '';
}

onMounted(async () => {
  checkSessionValidate(1)
  const route = useRoute();
  code = route.params.id;
  selectedOrganization.value = code || '';
  getFees();
  getOperators();
  getOrganizations();
  getTypeFees();
  getCountries();

  setTimeout(function () {
    pageLoad.value = true;
  }, 1000)
});
</script>